import React, { ReactNode, useState } from 'react';
import styles from './Tooltip.module.scss';

interface TooltipProps {
  children: ReactNode;
  content: string | ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  disabled?: boolean;
  className?: string;
  maxWidth?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  position = 'bottom', // Changed default to bottom
  disabled = false,
  className = '',
  maxWidth = 450 // Much wider default to prevent word-per-line issues
}) => {
  const [isVisible, setIsVisible] = useState(false);

  if (disabled || !content) {
    return <>{children}</>;
  }

  return (
    <div
      className={`${styles.tooltip_wrapper} ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`${styles.tooltip} ${styles[`tooltip_${position}`]}`}
          style={{ maxWidth: `${maxWidth}px` }}
        >
          <div className={styles.tooltip_content}>
            {content}
          </div>
          <div className={styles.tooltip_arrow}></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
